import { useCallback } from 'react'
import { NavigateOptions, To, useNavigate } from 'react-router-dom'

import { withViewTransition } from '../helpers/viewTransition'

/**
 * Same as react-router's `useNavigate`, but cross-fades the page content using the native
 * View Transitions API (see `withViewTransition` for why this app can't rely on
 * react-router's own, data-router-only view transition support).
 */
export const useViewTransitionNavigate = () => {
  const navigate = useNavigate()

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      withViewTransition(() => (typeof to === 'number' ? navigate(to) : navigate(to, options)))
    },
    [navigate]
  )
}
